var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"ma-0 pb-2",attrs:{"cols":"12"}},[_c('div',{staticClass:"text-center line"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }